export default __webpack_public_path__ + "static/media/Control.155df5b5.svg";